<template>
    <b-modal
        id="message-primary-seller-modal"
        title="Message Primary Seller"
        title-tag="h2"
        body-class="pt-0 pb-4"
        hide-footer
        dialog-class="message-primary-seller-modal"
    >

        <div class="mb-3">
            <p>Would you like to inform <strong>{{ getPrimarySellerFullName }}</strong> to make disclosure edits?</p>
            <b-form-textarea
                id="textarea"
                placeholder="Type here..."
                rows="4"
                max-rows="6"
                class="overflow-auto"
                :class="error ? 'error' : ''"
                v-model="message"
            ></b-form-textarea>
            <p v-if="error" class="text-red">Your message is too short.</p>
        </div>

        <b-form-row class="justify-content-end">
            <b-col cols="auto">
                <b-button
                    class="text-dark"
                    variant="tertiary"
                    size="lg"
                    @click="$bvModal.hide(id)"
                >
                    Cancel
                </b-button>
            </b-col>

            <b-col cols="4">
                <b-button
                    variant="primary"
                    size="lg"
                    block
                    @click="sendMessage"
                >
                    <b-spinner
                        class="mr-1"
                        small
                        v-if="loading"
                    />
                    Send
                </b-button>
            </b-col>
        </b-form-row>
    </b-modal>
</template>

<script>
import './MessagePrimarySeller.scss';
import ShowNotificationMixin from "@sellers-shield-home-protection/ss-ui-kit/src/mixins/ShowNotificationMixin";
import FrontEndApiService from "@services/frontend.api.service";
import {primarySellerName} from "@helpers/order";
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";

export default {
    name: "MessagePrimarySeller",
    mixins: [
        ShowNotificationMixin,
    ],
    props: {
        id: {
            type: String,
            default: 'message-primary-seller-modal',
        },
        order: {
            type: OrderAppResource,
            required: true
        },
        orderUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            message: '',
            error: false
        };
    },
    computed: {
        getPrimarySellerFullName() {
            return !!primarySellerName(this.order) ? primarySellerName(this.order) : 'the primary seller';
        }
    },
    methods: {
        async sendMessage() {
            this.loading = true;

            if (!this.validate()) {
                try {
                    const data = {
                        message: this.message,
                        message_type: 'message-primary-seller'
                    };

                    const response = await FrontEndApiService.post(`public-api/v1/orders/${this.orderUuid}/message-primary-seller`, data);

                    if (response.status === 200) {
                        this.showNotification({
                            message: 'Your message has been sent successfully!',
                            type: 'success'
                        });

                        this.message = '';
                        this.$bvModal.hide(this.id);
                    }
                } catch (e) {
                    console.error(e);
                    this.showNotification({
                        message: 'Something went wrong! Your message couldn\'t be delivered.',
                        type: 'error'
                    });
                }
            }

            this.loading = false;
        },
        validate() {
            this.error = !this.message;
            return this.error;
        }
    }
}
</script>